(function () {
  var kits = {
    sword: {
      standard: {
        sku: "Y-FA-70 + WEAPON-BLOCK-REFILL",
        title: "雷霆木块剑标准套装",
        copy: "适合作为第一把武器：按编号拼装，双面印刷，完成后可解锁剑身传说。",
        basePrice: 129,
        includes: ["3D 打印黑色剑框架", "86 颗编号印刷木块", "符文小游戏入口", "武器收纳展示建议"]
      },
      legend: {
        sku: "Y-FA-70-LEGEND + AI-LORE-CARD",
        title: "雷霆木块剑 AI 传说套装",
        copy: "在标准套装基础上加入 AI 武器传说、角色称号和可分享的武器档案。",
        basePrice: 159,
        includes: ["3D 打印黑色剑框架", "86 颗双面图案木块", "AI 武器传说卡", "符文小游戏入口"]
      }
    },
    hammer: {
      standard: {
        sku: "Y-FA-115 + HAMMER-BLOCK-REFILL",
        title: "四叶战锤标准套装",
        copy: "作为第二武器线，用绿色四叶图案做幸运战锤，适合复购和组合套装。",
        basePrice: 139,
        includes: ["3D 打印黑色锤框架", "编号印刷木块", "幸运符文图案", "武器称号入口"]
      },
      legend: {
        sku: "Y-FA-115-LEGEND + AI-QUEST-CARD",
        title: "四叶战锤 AI 任务套装",
        copy: "完成战锤后解锁守护者任务，让锤子系列成为剑系列之后的自然扩展。",
        basePrice: 169,
        includes: ["3D 打印黑色锤框架", "双面图案木块", "AI 任务剧情卡", "组合武器档案"]
      }
    }
  };

  var storyWorlds = {
    thunder: [
      ["第一章：武器觉醒", "雷晶剑身开始发光", "{name}把第 62 号木块压进剑柄，蓝色雷纹从剑尖亮到护手。AI 档案记录：这是一把只回应勇气的雷霆剑。"],
      ["第二章：编号试炼", "第 86 块归位", "{name}完成最后一块编号木块，剑身背面的隐藏图案浮现出来：下一场试炼需要点亮九枚符文。"]
    ],
    clover: [
      ["第一章：四叶战锤", "幸运核心被唤醒", "{name}把绿色核心块放入锤面中央，四叶纹样开始旋转。AI 档案记录：这把战锤会保护愿意修复世界的人。"],
      ["第二章：山脉工匠", "锤柄开出白花", "{name}敲响战锤底部，锤柄上的白花图案连接成路线，指向豆豆大陆的山脉工坊。"]
    ],
    shadow: [
      ["隐藏章：暗影武器", "背面图案不是装饰", "{name}翻转一颗双面印刷木块，背面编号组成暗影坐标。AI 档案提示：有些武器必须从反面读懂。"],
      ["隐藏章：未命名骑士", "称号正在生成", "{name}完成符文点亮后，系统给出新称号：未命名骑士。下一把武器会决定阵营。"]
    ]
  };

  var targetCells = [2, 7, 11, 12, 13, 16, 17, 18, 22];

  function burst(x, y) {
    for (var i = 0; i < 7; i += 1) {
      var node = document.createElement("span");
      var angle = (Math.PI * 2 * i) / 7;
      var distance = 24 + i * 3;
      node.className = "doudou__burst";
      node.style.left = x + "px";
      node.style.top = y + "px";
      node.style.setProperty("--burst-x", Math.cos(angle) * distance + "px");
      node.style.setProperty("--burst-y", Math.sin(angle) * distance + "px");
      document.body.appendChild(node);
      window.setTimeout(function (el) {
        el.remove();
      }, 560, node);
    }
  }

  function getState(root) {
    return {
      kit: root.dataset.doudouKit || "sword",
      finish: root.dataset.doudouFinish || "standard",
      frames: Number(root.dataset.doudouFrames || 1)
    };
  }

  function setActive(root, selector, attr, value) {
    root.querySelectorAll(selector).forEach(function (button) {
      button.classList.toggle("is-active", button.getAttribute(attr) === value);
    });
  }

  function renderBuilder(root) {
    var state = getState(root);
    var data = kits[state.kit][state.finish];
    var price = data.basePrice + state.frames * 19;
    var includes = data.includes.slice();
    includes.splice(2, 0, state.frames + " 包补充木块");

    setActive(root, "[data-doudou-kit]", "data-doudou-kit", state.kit);
    setActive(root, "[data-doudou-finish]", "data-doudou-finish", state.finish);

    var sku = root.querySelector("[data-doudou-sku]");
    var title = root.querySelector("[data-doudou-kit-title]");
    var copy = root.querySelector("[data-doudou-kit-copy]");
    var list = root.querySelector("[data-doudou-includes]");
    var priceNode = root.querySelector("[data-doudou-price]");
    var frameCount = root.querySelector("[data-doudou-frame-count]");

    if (sku) sku.textContent = data.sku;
    if (title) title.textContent = data.title;
    if (copy) copy.textContent = data.copy;
    if (priceNode) priceNode.textContent = "¥" + price + " 起";
    if (frameCount) frameCount.textContent = String(state.frames);
    if (list) {
      list.innerHTML = "";
      includes.forEach(function (item) {
        var li = document.createElement("li");
        li.textContent = item;
        list.appendChild(li);
      });
    }
  }

  function renderStory(root) {
    var world = root.dataset.doudouStoryWorld || "thunder";
    var stories = storyWorlds[world];
    var index = Number(root.dataset.doudouStoryIndex || 0) % stories.length;
    var story = stories[index];
    var nameInput = root.querySelector("[data-doudou-hero-name]");
    var name = nameInput && nameInput.value.trim() ? nameInput.value.trim() : "豆豆骑士";
    setActive(root, "[data-doudou-story-world]", "data-doudou-story-world", world);

    var label = root.querySelector("[data-doudou-story-label]");
    var title = root.querySelector("[data-doudou-story-title]");
    var text = root.querySelector("[data-doudou-story-text]");
    if (label) label.textContent = story[0];
    if (title) title.textContent = story[1];
    if (text) text.textContent = story[2].replace("{name}", name);
  }

  function renderGame(root) {
    var board = root.querySelector("[data-doudou-board]");
    if (!board || board.dataset.ready === "true") return;
    board.dataset.ready = "true";
    for (var i = 0; i < 25; i += 1) {
      var cell = document.createElement("button");
      cell.type = "button";
      cell.className = "doudou__cell";
      cell.setAttribute("aria-label", "符文 " + (i + 1));
      cell.dataset.cell = String(i);
      if (targetCells.indexOf(i) !== -1) cell.classList.add("is-target");
      board.appendChild(cell);
    }
  }

  function updateGame(root) {
    var activeTargets = 0;
    targetCells.forEach(function (index) {
      var cell = root.querySelector('[data-cell="' + index + '"]');
      if (cell && cell.classList.contains("is-active")) activeTargets += 1;
    });
    var score = root.querySelector("[data-doudou-game-score]");
    var copy = root.querySelector("[data-doudou-game-copy]");
    if (score) score.textContent = activeTargets + " / " + targetCells.length;
    if (copy) {
      copy.textContent = activeTargets === targetCells.length
        ? "剑身九枚符文已点亮，称号「雷晶骑士」进入武器档案。"
        : activeTargets >= 4
          ? "剑身符文开始发光。"
          : "剑身符文还在沉睡。";
    }
    return activeTargets === targetCells.length;
  }

  function addToCount(root, amount) {
    var current = Number(root.dataset.doudouCount || 0) + amount;
    root.dataset.doudouCount = String(current);
    root.querySelectorAll("[data-doudou-cart-count]").forEach(function (node) {
      node.textContent = String(current);
    });
  }

  function init(root) {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";
    root.dataset.doudouKit = "sword";
    root.dataset.doudouFinish = "standard";
    root.dataset.doudouFrames = "1";
    root.dataset.doudouStoryWorld = "thunder";
    root.dataset.doudouStoryIndex = "0";
    root.dataset.doudouRewarded = "false";

    root.querySelectorAll("[data-doudou-kit], [data-doudou-kit-shortcut]").forEach(function (button) {
      button.addEventListener("click", function () {
        root.dataset.doudouKit = button.getAttribute("data-doudou-kit") || button.getAttribute("data-doudou-kit-shortcut");
        renderBuilder(root);
        document.getElementById("doudou-builder")?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    root.querySelectorAll("[data-doudou-finish], [data-doudou-finish-shortcut]").forEach(function (button) {
      button.addEventListener("click", function () {
        root.dataset.doudouFinish = button.getAttribute("data-doudou-finish") || button.getAttribute("data-doudou-finish-shortcut");
        renderBuilder(root);
        document.getElementById("doudou-builder")?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    var plus = root.querySelector("[data-doudou-frame-plus]");
    var minus = root.querySelector("[data-doudou-frame-minus]");
    if (plus) {
      plus.addEventListener("click", function () {
        root.dataset.doudouFrames = String(Math.min(12, getState(root).frames + 1));
        renderBuilder(root);
      });
    }
    if (minus) {
      minus.addEventListener("click", function () {
        root.dataset.doudouFrames = String(Math.max(0, getState(root).frames - 1));
        renderBuilder(root);
      });
    }

    root.querySelectorAll("[data-doudou-add]").forEach(function (add) {
      add.addEventListener("click", function (event) {
        addToCount(root, 1);
        burst(event.clientX, event.clientY);
      });
    });

    root.querySelectorAll("[data-doudou-story-world]").forEach(function (button) {
      button.addEventListener("click", function () {
        root.dataset.doudouStoryWorld = button.getAttribute("data-doudou-story-world");
        root.dataset.doudouStoryIndex = "0";
        renderStory(root);
      });
    });

    var generate = root.querySelector("[data-doudou-story-generate]");
    if (generate) {
      generate.addEventListener("click", function (event) {
        root.dataset.doudouStoryIndex = String(Number(root.dataset.doudouStoryIndex || 0) + 1);
        renderStory(root);
        burst(event.clientX, event.clientY);
      });
    }

    var heroName = root.querySelector("[data-doudou-hero-name]");
    if (heroName) {
      heroName.addEventListener("input", function () {
        renderStory(root);
      });
    }

    renderGame(root);
    var board = root.querySelector("[data-doudou-board]");
    if (board) {
      board.addEventListener("click", function (event) {
        var cell = event.target.closest("[data-cell]");
        if (!cell) return;
        cell.classList.toggle("is-active");
        var complete = updateGame(root);
        burst(event.clientX, event.clientY);
        if (complete && root.dataset.doudouRewarded !== "true") {
          root.dataset.doudouRewarded = "true";
          addToCount(root, 1);
        }
      });
    }

    var reset = root.querySelector("[data-doudou-game-reset]");
    if (reset) {
      reset.addEventListener("click", function () {
        root.querySelectorAll("[data-cell]").forEach(function (cell) {
          cell.classList.remove("is-active");
        });
        root.dataset.doudouRewarded = "false";
        updateGame(root);
      });
    }

    renderBuilder(root);
    renderStory(root);
    updateGame(root);
  }

  function initAll() {
    document.querySelectorAll("[data-doudou-store]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-doudou-store]").forEach(init);
  });
})();
